// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"85c23d19","208":"9279414a","293":"54cdf27b","453":"0ba2bcbf","516":"58237b7c","917":"756a2dab","946":"efddab7a"}[chunkId] + ".chunk.js";
};